// src/utils/timecardUtils.js

export const EXCLUDED_POSITIONS = ["Student", "Resident", "Volunteer"];

export function isExcluded(position = "") {
  return EXCLUDED_POSITIONS.includes(String(position));
}

export function isTrinityEmployee(user) {
  return String(user?.isEmployee || "").toLowerCase() === "yes";
}

export function hasEmployeeNumber(user) {
  return !!String(user?.employeeNumber || "").trim();
}

export function shouldIncludeInPayroll(user) {
  if (!user) return false;
  if (isExcluded(user.position)) return false;
  return true;
}

export function isTrinityPayroll(user) {
  return (
    shouldIncludeInPayroll(user) &&
    isTrinityEmployee(user) &&
    hasEmployeeNumber(user)
  );
}

export function isNonTrinityPayroll(user) {
  return (
    shouldIncludeInPayroll(user) &&
    (!isTrinityEmployee(user) || !hasEmployeeNumber(user))
  );
}

export function shouldShowPay(user) {
  // Trinity employees → NO PAY
  return !isTrinityEmployee(user);
}

export function sortEmployeesAlphabetically(arr = []) {
  return [...arr].sort((a, b) => {
    const aName = (a.displayName || "").toLowerCase();
    const bName = (b.displayName || "").toLowerCase();
    return aName.localeCompare(bName);
  });
}

export function getPayPeriodEndDate(weekStart) {
  const d = new Date(weekStart);
  d.setDate(d.getDate() + 6);
  return d;
}